import { style } from '@mui/system';
import React from 'react';
import styles from './Hero.module.css';
import { Facebook, Twitter, LinkedIn, GitHub, Telegram, WhatsApp } from '@mui/icons-material'
import jhay from '../../images/logo1.png';
import Aos from 'aos';
import 'aos/dist/aos.css';



export default function Hero () {

  React.useEffect(() => {
    Aos.init({duration: 2000})
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.details} data-aos='fade-right'>
        <h1> Ezelu </h1>
        <p> Hi, I'm Joseph John Ezelu </p>
        <p> I'm a <span> Full Stack developer </span> from Nigeria. </p>
        <i className={styles.subtitle}> I make <span> modern, creative, clean,  interactive and scalable </span> web products with <span> awesome user experiences. </span> </i>

        <aside>
          <a href="https://facebook.com/ezelujhay1"  target="_blank" title='Facebook'> <Facebook /> </a>
          <a href="https://twitter.com/ezelujhay"  target="_blank" title='Twitter'> <Twitter /> </a>
          <a href="https://linkedin.com/in/ezelujhay"  target="_blank" title="LinkedIn"> <LinkedIn /> </a>
          <a href="https://github.com/ezelu"  target="_blank" title="Github"> <GitHub /> </a>
          <a href="https://wa.me/+2347085186134" title="Email" target="_blank" > <WhatsApp /> </a>
          <a href="https://t.me/ezelu_jhay"  target="_blank" title='Telegram'> <Telegram /> </a>
        </aside>
      </div>

      <div className={styles.img_container} data-aos='fade-right'>
        <img src={jhay} alt="A handsome picture of me!:)"/>
      </div>
    </div>
  )
}